import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import Skeleton from "react-loading-skeleton";
import {FaCalendar, FaClock, FaUserMd, FaHospitalAlt, FaBuilding, FaCalendarDay} from "react-icons/fa";
import ApiService from "../util/ApiService";
import MapIframe from "../util/MapIframe";
import ScaleModal from "../dashboard/calender/scaleModal";
import AuthService from "../util/AuthService";

const weekDays = [
    "Domingo", "Segunda-feira", "Terça-feira",
    "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"
];

const ScaleModaInfo = ({show, handleClose, id, scaleOrigin}) => {
    const [loading, setLoading] = useState(true);
    const [scale, setScale] = useState({});
    const [scaleEdit, setScaleEdit] = useState({});
    const [showScaleModal, setShowScaleModal] = useState(null);
    const user = AuthService.getUserData();

    const [hospitalOptions, setHospitalOptions] = useState(null); // <-- AQUI
    const [userOptions, setUserOptions] = useState(null);

    useEffect(() => {
        if (show && id) {
            fetchScale();
        }
    }, [show, id]);

    const fetchScale = async () => {
        setLoading(true);
        try {
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}scale/onerecord/${id}`, null, true);
            const {data} = ApiService.handleApiResponse(response);
            setScale(data);
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleScaleModalClose = (save = false, updatedScale = null) => {
        setShowScaleModal(false);

        // Verifica se foi a escala de origem (scaleOrigin.id)
        if (save && updatedScale?.id === scaleOrigin?.id) {
            handleClose(updatedScale); // envia para o ScalePostingModal
        } else {
            handleClose(); // fechamento padrão
        }
    };


    const handleModalOpen = (scale) => {
        setScaleEdit(scale);
        setShowScaleModal(true);
    };

    const formatCurrency = (value) =>
        parseFloat(value || 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL"});

    return (
        <>
            <Modal show={show} onHide={handleClose} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes da Escala</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? (
                        <Skeleton count={6}/>
                    ) : (
                        <div className="row">

                            <div className="col-md-12 mb-4">
                                <strong>{scale.user?.name || "Usuário não vinculado"}</strong>
                            </div>


                            <div className="col-md-6 mb-2">
                                <FaHospitalAlt className="me-2 text-info"/>
                                {scaleOrigin.hospital?.name} - {scale.hospital?.city_name}/{scale.hospital?.uf}

                            </div>
                            <div className="col-md-6 mb-2">
                                <FaHospitalAlt className="me-2 text-info"/>
                                {scale.hospital?.name} - {scale.hospital?.city_name}/{scale.hospital?.uf}
                            </div>

                            <div className="col-md-6 mb-2">
                                <FaBuilding className="me-2 text-info"/>
                                {scaleOrigin.department?.name || "—"}

                            </div>
                            <div className="col-md-6 mb-2">
                                <FaBuilding className="me-2 text-info"/>
                                {scale.department?.name || "—"}

                            </div>
                            <div className="col-md-6 mb-2">
                                <FaCalendar className="me-2 text-info"/>
                                {scaleOrigin.order_month === 0 ? "Toda semana" : `${scaleOrigin.order_month}ª semana`}

                            </div>
                            <div className="col-md-6 mb-2">
                                <FaCalendarDay className="me-2 text-info"/>
                                {scale.order_month === 0 ? "Toda semana" : `${scale.order_month}ª semana`}

                            </div>
                            <div className="col-md-6 mb-2">
                                <FaCalendar className="me-2 text-info"/>
                                {weekDays[scaleOrigin.duty_scale_day_wee_id]}

                            </div>
                            <div className="col-md-6 mb-2">
                                <FaCalendar className="me-2 text-info"/>
                                {weekDays[scale.duty_scale_day_wee_id]}

                            </div>
                            <div className="col-md-6 mb-2">
                                <FaClock className="me-2 text-info"/>
                                {scaleOrigin.time_begin?.slice(0, 5)} - {scaleOrigin.time_end?.slice(0, 5)} ({scaleOrigin.total_hours?.slice(0, 5)})
                            </div>
                            <div className="col-md-6 mb-2">
                                <FaClock className="me-2 text-info"/>
                                {scale.time_begin?.slice(0, 5)} - {scale.time_end?.slice(0, 5)} ({scale.total_hours?.slice(0, 5)})
                            </div>


                            <div className="col-md-6 mb-2">

                                <i className="fa fa-money text-info me-2"/>
                                {formatCurrency(scaleOrigin.value)}

                            </div>
                            <div className="col-md-6 mb-2">

                                <i className="fa fa-money text-info me-2"/>
                                {formatCurrency(scale.value)}

                            </div>
                            <div className="col-md-6 mb-2">

                                {scale.observation && (
                                    <>
                                        <i className="fa fa-sticky-note text-info me-2"/>
                                        {scaleOrigin.observation}

                                    </>)}
                            </div>
                            <div className="col-md-6 mb-2">

                                {scale.observation && (
                                    <>
                                        <i className="fa fa-sticky-note text-info me-2"/>
                                        Observação: {scale.observation}

                                    </>)}
                            </div>
                            <div className="row mt-3">


                                {scaleOrigin.logged_in_user === user.id && (
                                    <div className="col-md-6 mb-2 d-flex align-items-center">
                                        <button type="button" className="btn btn-info w-100"
                                                onClick={() => handleModalOpen(scaleOrigin)}>
                                            <i className="fa fa-edit me-1"></i> Editar Origem
                                        </button>
                                    </div>
                                )}

                                {scale.logged_in_user === user.id && (
                                    <div className="col-md-6 mb-2 d-flex align-items-center">
                                        <button type="button" className="btn btn-info w-100"
                                                onClick={() => handleModalOpen(scale)}>
                                            <i className="fa fa-edit me-1"></i> Editar Conflitado
                                        </button>
                                    </div>
                                )}
                            </div>

                        </div>


                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary mt-3" onClick={handleClose}>
                        <i className="fa fa-close me-1"></i> Fechar
                    </button>

                </Modal.Footer>
            </Modal>


            {showScaleModal && (
                <ScaleModal
                    scale={scaleEdit}
                    show={showScaleModal}
                    handleClose={handleScaleModalClose}
                />
            )}
        </>
    );
};

export default ScaleModaInfo;
